import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { CAUSAS_NOTIFICACION } from './../../../../../constants/constants';

import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from "@angular/material/dialog";

//SERVICIOS
import { DocumentoService } from 'src/app/services/documento.service';
import { TransportistaService } from 'src/app/services/transportista.service';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';
import { LoginService } from 'src/app/services/login.service';


@Component({
  selector: 'app-documentos-transportista',
  templateUrl: './documentos-transportista.component.html',
  styleUrls: ['./documentos-transportista.component.scss']
})
export class DocumentosTransportistaComponent implements OnInit {

  public files: NgxFileDropEntry[] = [];
  public documentos: any;
  public datosDocumento: any = {};
  public date: any
  public otherDate: any
  public fecha: any
  public fileName: any
  public causasNotificacion: String[];
  public path: any;
  public transportista: any
  public transportistaId: any
  public datepicker: any
  public url: any;
  nameDocumento:any
  userLog:any
  constructor(@Inject(MAT_DIALOG_DATA) public info: {

    id: string,
    nAuth: any,
    refresh: any
  },
    private formBuilder: FormBuilder,
    private apollo: Apollo,
    private documentoServicio: DocumentoService,
    private router: Router,
    private transportistaService: TransportistaService,
    private uploadService: UploadDocumentosService,
    private loginService: LoginService) {
    this.causasNotificacion = CAUSAS_NOTIFICACION
    this.path = this.router.url
    this.buildForm();
    this.date = new Date()
    this.userLog = loginService.getUserData()
  }

  ngOnInit() {
    this.getTransportistaById();

  }

  fileLeave(){

  }
  fileOver(){

  }

  dropped(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento = res[0].name;
      this.url = res[0].url
    })
    
   }

  private buildForm() {
    this.datosDocumento = this.formBuilder.group({
      nombre: [''],
      fechaValidez: ['', [Validators.required]],
      fechaCaducidad: ['', [Validators.required]],
      noCaduca: [''],
    });
  }

  getDate(fecha: any) {
    this.date = moment(new Date(fecha)).format('Y-MM-DD')
  }

  getOtherDate(fecha: any) {
    this.otherDate = moment(new Date(fecha)).format('Y-MM-DD')
    
  }

  

  getTransportistaById() {
    console.log(this.info)
    this.apollo.watchQuery<any>({
      query: this.transportistaService.getTransportistaById(),
      variables: {
        id: this.info.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.transportista = data.transportista;
      })
  }

  getDocumentosByTransportista(): void {
    console.log(this.transportista)
    this.apollo.watchQuery<any>({
      query: this.documentoServicio.getDocumentosByTransportistaBar(),
      variables: {
        id: this.transportista.id
      }
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
      
       
      })
  }


  addDocumento() {
    console.log(this.datosDocumento.value.noCaduca);
    
    if (this.datosDocumento.value.noCaduca === '') {
      this.datosDocumento.value.noCaduca = null
    }
    this.getDate(this.datosDocumento.value.fechaValidez)
    if (this.datosDocumento.value.fechaCaducidad) {
      this.getOtherDate(this.datosDocumento.value.fechaCaducidad)
    }
  
    
    switch (this.info.nAuth) {

      case 'auth1':
        this.apollo.mutate<any>({
          mutation: this.documentoServicio.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "autorizacion1",
                "transportista": this.info.id,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.userLog.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)

        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
        break;

      case 'auth2':
        this.apollo.mutate<any>({
          mutation: this.documentoServicio.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "autorizacion2",
                "transportista": this.info.id,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.userLog.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)

        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
        break;

      case 'auth3':
        this.apollo.mutate<any>({
          mutation: this.documentoServicio.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "autorizacion3",
                "transportista": this.info.id,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.userLog.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)

        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
        break;

      case 'auth4':
        this.apollo.mutate<any>({
          mutation: this.documentoServicio.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "autorizacion4",
                "transportista": this.info.id,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.userLog.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)

        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
        break;

      case 'auth5':
        this.apollo.mutate<any>({
          mutation: this.documentoServicio.addDocumento(),
          variables: {
            "input": {
              "data": {
                "nombre": this.nameDocumento,
                "fechaValidez": this.date,
                "fechaCaducidad": this.otherDate,
                "noCaduca": this.datosDocumento.value.noCaduca,
                "obligatorio": true,
                "tipo": "pendiente",
                "nombreArchivo": "autorizacion5",
                "transportista": this.info.id,
                "url": this.url,
                "validado": false,
                "comentariosNuevos": true,
                "subidoPor": this.userLog.id
              }
            }
          }
        }).subscribe(({ data }) => {
          console.log('OK', data)

        }, (error) => {
          console.log('Error al lanzar la query', error);
        })
        break;

      default:
        break;
    }
  }

}
